//import { TokenClaims } from "node_modules/@azure/msal-common/dist/exports-common";
import { IdTokenClaims } from "@azure/msal-browser";
// User interface for handling token claims
export interface IUser {
  [x: string]: any;
  agentId?: string;
  // Identifiers and basic info
  homeAccountId: string; // Home account identifier
  environment: string; // Issuer's domain
  tenantId: string; // Tenant ID
  localAccountId: string; // Local account identifier
  username: string; // Preferred username
  name?: string; // Full name
  idToken?: string; // Raw ID token
  idTokenClaims?: IdTokenClaims & {
    [key: string]: string | number | string[] | object | undefined | unknown;
  };
  nativeAccountId?: string; // Native account ID
  roles: string | string[]; // User roles
  rolesOnly: string[]; // Array of roles only
  permissionsOnly: string[]; // Array of permissions only
  emails: string[];
  // Additional properties
  city: string; // User's city
  aud: string; // Audience claim
  auth_time: number; // Authentication time
  exp: number; // Expiration time
  iat: number; // Issued at time
  iss: string; // Issuer
  nbf: number; // Not before
  nonce: string; // Nonce
  tfp: string; // Trust Framework Policy
  ver: string; // Version
  oid?: any;
  acr?: any;
}
// Interface for the appId and the lastStep completed by a user
export interface IApplicantInfo {
  status: string;
  appId: string;
  lastStep: number;
  EliOption: string;
  countryOA: string;
}

export class ApplicantInfo implements IApplicantInfo {
  status: string = null;
  appId: string = null;
  lastStep: number = null;
  EliOption: string = null;
  countryOA: string = null;
}

export enum EUserType {
  Applicant = "applicant",
  Agent = "agent",
}
